import { render } from "./MaturityCard.vue?vue&type=template&id=0f94b6a3&scoped=true"
import script from "./MaturityCard.vue?vue&type=script&lang=js"
export * from "./MaturityCard.vue?vue&type=script&lang=js"

import "./MaturityCard.vue?vue&type=style&index=0&id=0f94b6a3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f94b6a3"]])

export default __exports__